
import acer_default from "../assets/images/acer_default.jpg";
import acer_default1 from "../assets/images/acer_default1.jpg";
import acer_default2 from "../assets/images/acer_default2.jpg";
import acer_default2b from "../assets/images/acer_default2b.jpg";
import acer_default3 from "../assets/images/acer_default3.jpg";
import acer_default4 from "../assets/images/acer_default4.jpg";
import acer_default5 from "../assets/images/acer_default5.jpg";

import lenovo_default from "../assets/images/lenovo_default.jpg";
import lenovo_default1 from "../assets/images/lenovo_default1.jpg";
import lenovo_default2 from "../assets/images/lenovo_default2.jpg";
import lenovo_default3 from "../assets/images/lenovo_default3.jpg";
import lenovo_default4 from "../assets/images/lenovo_default4.jpg";
import lenovo_default5 from "../assets/images/lenovo_default5.jpg";
import lenovo_default6 from "../assets/images/lenovo_default6.jpg";
import lenovo_default7 from "../assets/images/lenovo_default7.jpg";

import asus_default from "../assets/images/asus_default.jpg";
import asus_default1 from "../assets/images/asus_default1.jpg";
import asus_default2 from "../assets/images/asus_default2.jpg";
import asus_default3 from "../assets/images/asus_default3.jpg";
import asus_default4 from "../assets/images/asus_default4.jpg";
import asus_default5 from "../assets/images/asus_default5.jpg";
import asus_default6 from "../assets/images/asus_default6.jpg";
import asus_default7 from "../assets/images/asus_default7.jpg";
import asus_default8 from "../assets/images/asus_default8.jpg";

import msi_default from "../assets/images/msi_default.jpg";
import msi_default1 from "../assets/images/msi_default1.jpg";
import msi_default2 from "../assets/images/msi_default2.jpg";
import msi_default3 from "../assets/images/msi_default3.jpg";
import msi_default4 from "../assets/images/msi_default4.jpg";
import msi_default5 from "../assets/images/msi_default5.jpg";
import msi_default6 from "../assets/images/msi_default6.jpg";
import msi_default7 from "../assets/images/msi_default7.jpg";
import msi_default8 from "../assets/images/msi_default8.jpg";

import hp_default from "../assets/images/hp_default.jpg";
import hp_default1 from "../assets/images/hp_default1.jpg";
import hp_default2 from "../assets/images/hp_default2.jpg";
import hp_default3 from "../assets/images/hp_default3.jpg";
import hp_default4 from "../assets/images/hp_default4.jpg";
import hp_default5 from "../assets/images/hp_default5.jpg";
import hp_default6 from "../assets/images/hp_default6.jpg";
import hp_default7 from "../assets/images/hp_default7.jpg";
import hp_default8 from "../assets/images/hp_default8.jpg";

import dell_default from "../assets/images/dell_default.jpg";
import dell_default1 from "../assets/images/dell_default1.jpg";
import dell_default2 from "../assets/images/dell_default2.jpg";
import dell_default3 from "../assets/images/dell_default3.jpg";
import dell_default4 from "../assets/images/dell_default4.jpg";
import dell_default5 from "../assets/images/dell_default5.jpg";
import dell_default6 from "../assets/images/dell_default6.jpg";
import dell_default7 from "../assets/images/dell_default7.jpg";
import dell_default8 from "../assets/images/dell_default8.jpg";

import apple_default from "../assets/images/apple_default.jpg";
import apple_default1 from "../assets/images/apple_default1.jpg";
import apple_default2 from "../assets/images/apple_default2.jpg";
import apple_default3 from "../assets/images/apple_default3.jpg";
import apple_default4 from "../assets/images/apple_default4.jpg";
import apple_default5 from "../assets/images/apple_default5.jpg";
import apple_default6 from "../assets/images/apple_default6.jpg";
import apple_default7 from "../assets/images/apple_default7.jpg";
import apple_default8 from "../assets/images/apple_default8.jpg";


import desktop_acer_default1 from "../assets/images/desktop_acer_default1.jpg";
import desktop_acer_default2 from "../assets/images/desktop_acer_default2.jpg";
import desktop_acer_default3 from "../assets/images/desktop_acer_default3.jpg";
import desktop_acer_default4 from "../assets/images/desktop_acer_default4.jpg";
import desktop_acer_default5 from "../assets/images/desktop_acer_default5.jpg";
import desktop_acer_default6 from "../assets/images/desktop_acer_default6.jpg";
import desktop_asus_default1 from "../assets/images/desktop_asus_default1.jpg";
import desktop_asus_default2 from "../assets/images/desktop_asus_default2.jpg";
import desktop_asus_default3 from "../assets/images/desktop_asus_default3.jpg";
import desktop_asus_default4 from "../assets/images/desktop_asus_default4.jpg";
import desktop_asus_default5 from "../assets/images/desktop_asus_default5.jpg";
import desktop_dell_default1 from "../assets/images/desktop_dell_default1.jpg";
import desktop_dell_default2 from "../assets/images/desktop_dell_default2.jpg";
import desktop_dell_default3 from "../assets/images/desktop_dell_default3.jpg";
import desktop_hp_default1 from "../assets/images/desktop_hp_default1.jpg";
import desktop_hp_default2 from "../assets/images/desktop_hp_default2.jpg";
import desktop_hp_default3 from "../assets/images/desktop_hp_default3.jpg";
import desktop_hp_default4 from "../assets/images/desktop_hp_default4.jpg";
import desktop_xiaomi_default1 from "../assets/images/desktop_xiaomi_default1.jpg";
import desktop_xiaomi_default2 from "../assets/images/desktop_xiaomi_default2.jpg";
import desktop_xiaomi_default3 from "../assets/images/desktop_xiaomi_default3.jpg";
import desktop_xiaomi_default4 from "../assets/images/desktop_xiaomi_default4.jpg";
import desktop_samsung_default1 from "../assets/images/desktop_samsung_default1.jpg";
import desktop_samsung_default2 from "../assets/images/desktop_samsung_default2.jpg";
import desktop_lenovo_default1 from "../assets/images/desktop_lenovo_default1.jpg";
import desktop_lenovo_default2 from "../assets/images/desktop_lenovo_default2.jpg";
import desktop_lenovo_default3 from "../assets/images/desktop_lenovo_default3.jpg";
import desktop_lenovo_default4 from "../assets/images/desktop_lenovo_default4.jpg";
import desktop_lenovo_default5 from "../assets/images/desktop_lenovo_default5.jpg";
import desktop_msi_default1 from "../assets/images/desktop_msi_default1.jpg";
import desktop_msi_default2 from "../assets/images/desktop_msi_default2.jpg";
import desktop_msi_default3 from "../assets/images/desktop_msi_default3.jpg";
import desktop_msi_default4 from "../assets/images/desktop_msi_default4.jpg";


import pccomponents_ac_default1 from "../assets/images/pccomponents_ac_default1.jpg";
import pccomponents_ac_default2 from "../assets/images/pccomponents_ac_default2.jpg";
import pccomponents_ac_default3 from "../assets/images/pccomponents_ac_default3.jpg";
import pccomponents_ac_default4 from "../assets/images/pccomponents_ac_default4.jpg";
import pccomponents_ac_default5 from "../assets/images/pccomponents_ac_default5.jpg";
import pccomponents_ac_default6 from "../assets/images/pccomponents_ac_default6.jpg";
import pccomponents_casing_default1 from "../assets/images/pccomponents_casing_default1.jpg";
import pccomponents_casing_default2 from "../assets/images/pccomponents_casing_default2.jpg";
import pccomponents_casing_default3 from "../assets/images/pccomponents_casing_default3.jpg";
import pccomponents_casing_default4 from "../assets/images/pccomponents_casing_default4.jpg";
import pccomponents_casing_default5 from "../assets/images/pccomponents_casing_default5.jpg";
import pccomponents_casing_default6 from "../assets/images/pccomponents_casing_default6.jpg";
import pccomponents_casing_default7 from "../assets/images/pccomponents_casing_default7.jpg";
import pccomponents_casing_default8 from "../assets/images/pccomponents_casing_default8.jpg";
import pccomponents_db_default1 from "../assets/images/pccomponents_db_default1.jpg";
import pccomponents_db_default2 from "../assets/images/pccomponents_db_default2.jpg";
import pccomponents_gcard_default1 from "../assets/images/pccomponents_gcard_default1.jpg";
import pccomponents_gcard_default2 from "../assets/images/pccomponents_gcard_default2.jpg";
import pccomponents_lc_default1 from "../assets/images/pccomponents_lc_default1.jpg";
import pccomponents_lc_default2 from "../assets/images/pccomponents_lc_default2.jpg";
import pccomponents_lc_default3 from "../assets/images/pccomponents_lc_default3.jpg";
import pccomponents_lc_default4 from "../assets/images/pccomponents_lc_default4.jpg";
import pccomponents_lc_default5 from "../assets/images/pccomponents_lc_default5.jpg";
import pccomponents_lc_default6 from "../assets/images/pccomponents_lc_default6.jpg";
import pccomponents_lc_default7 from "../assets/images/pccomponents_lc_default7.jpg";
import pccomponents_lc_default8 from "../assets/images/pccomponents_lc_default8.jpg";
import pccomponents_motherboard_default1 from "../assets/images/pccomponents_motherboard_default1.jpg";
import pccomponents_motherboard_default2 from "../assets/images/pccomponents_motherboard_default2.jpg";
import pccomponents_motherboard_default3 from "../assets/images/pccomponents_motherboard_default3.jpg";
import pccomponents_motherboard_default4 from "../assets/images/pccomponents_motherboard_default4.jpg";
import pccomponents_peripherals_default1 from "../assets/images/pccomponents_peripherals_default1.jpg";
import pccomponents_peripherals_default2 from "../assets/images/pccomponents_peripherals_default2.jpg";
import pccomponents_peripherals_default3 from "../assets/images/pccomponents_peripherals_default3.jpg";
import pccomponents_peripherals_default4 from "../assets/images/pccomponents_peripherals_default4.jpg";
import pccomponents_peripherals_default5 from "../assets/images/pccomponents_peripherals_default5.jpg";
import pccomponents_powersupply_default1 from "../assets/images/pccomponents_powersupply_default1.jpg";
import pccomponents_powersupply_default2 from "../assets/images/pccomponents_powersupply_default2.jpg";
import pccomponents_powersupply_default3 from "../assets/images/pccomponents_powersupply_default3.jpg";
import pccomponents_powersupply_default4 from "../assets/images/pccomponents_powersupply_default4.jpg";
import pccomponents_powersupply_default5 from "../assets/images/pccomponents_powersupply_default5.jpg";
import pccomponents_software_default1 from "../assets/images/pccomponents_software_default1.jpg";
import pccomponents_software_default2 from "../assets/images/pccomponents_software_default2.jpg";
import pccomponents_storage_default1 from "../assets/images/pccomponents_storage_default1.jpg";
import pccomponents_storage_default2 from "../assets/images/pccomponents_storage_default2.jpg";
import pccomponents_storage_default3 from "../assets/images/pccomponents_storage_default3.jpg";
import pccomponents_storage_default4 from "../assets/images/pccomponents_storage_default4.jpg";
import pccomponents_storage_default5 from "../assets/images/pccomponents_storage_default5.jpg";
import pccomponents_tp_default1 from "../assets/images/pccomponents_tp_default1.jpg";


import dms_dst_default1 from "../assets/images/dms_dst_default1.jpg";
import dms_dst_default2 from "../assets/images/dms_dst_default2.jpg";
import dms_dst_default3 from "../assets/images/dms_dst_default3.jpg";
import dms_dst_default4 from "../assets/images/dms_dst_default4.jpg";
import dms_rs_default1 from "../assets/images/dms_rs_default1.jpg";
import dms_rs_default2 from "../assets/images/dms_rs_default2.jpg";
import dms_rs_default3 from "../assets/images/dms_rs_default3.jpg";
import dms_rs_default4 from "../assets/images/dms_rs_default4.jpg";


import wearables_apple_default1 from "../assets/images/wearables_apple_default1.jpg";
import wearables_apple_default2 from "../assets/images/wearables_apple_default2.jpg";
import wearables_apple_default3 from "../assets/images/wearables_apple_default3.jpg";
import wearables_apple_default4 from "../assets/images/wearables_apple_default4.jpg";
import wearables_garmin_default1 from "../assets/images/wearables_garmin_default1.jpg";
import wearables_garmin_default2 from "../assets/images/wearables_garmin_default2.jpg";
import wearables_garmin_default3 from "../assets/images/wearables_garmin_default3.jpg";
import wearables_garmin_default4 from "../assets/images/wearables_garmin_default4.jpg";
import wearables_garmin_default5 from "../assets/images/wearables_garmin_default5.jpg";
import wearables_garmin_default6 from "../assets/images/wearables_garmin_default6.jpg";
import wearables_garmin_default7 from "../assets/images/wearables_garmin_default7.jpg";
import wearables_garmin_default8 from "../assets/images/wearables_garmin_default8.jpg";


import networking_starlink_default1 from "../assets/images/networking_starlink_default1.jpg";
import networking_starlink_default2 from "../assets/images/networking_starlink_default2.jpg";
import networking_starlink_default3 from "../assets/images/networking_starlink_default3.jpg";
import networking_starlink_default4 from "../assets/images/networking_starlink_default4.jpg";
import networking_starlink_default5 from "../assets/images/networking_starlink_default5.jpg";
import networking_starlink_default6 from "../assets/images/networking_starlink_default6.jpg";
import networking_asus_default1 from "../assets/images/networking_asus_default1.jpg";
import networking_asus_default2 from "../assets/images/networking_asus_default2.jpg";
import networking_asus_default3 from "../assets/images/networking_asus_default3.jpg";
import networking_asus_default4 from "../assets/images/networking_asus_default4.jpg";
import networking_asus_default5 from "../assets/images/networking_asus_default5.jpg";
import networking_asus_default6 from "../assets/images/networking_asus_default6.jpg";
import networking_dlink_default1 from "../assets/images/networking_dlink_default1.jpg";
import networking_dlink_default2 from "../assets/images/networking_dlink_default2.jpg";
import networking_totolink_default1 from "../assets/images/networking_totolink_default1.jpg";
import networking_totolink_default2 from "../assets/images/networking_totolink_default2.jpg";
import networking_tplink_default1 from "../assets/images/networking_tplink_default1.jpg";
import networking_tplink_default2 from "../assets/images/networking_tplink_default2.jpg";
import networking_tplink_default3 from "../assets/images/networking_tplink_default3.jpg";
import networking_tplink_default4 from "../assets/images/networking_tplink_default4.jpg";


import printer_brother_default1 from "../assets/images/printer_brother_default1.jpg";
import printer_brother_default2 from "../assets/images/printer_brother_default2.jpg";
import printer_hp_default1 from "../assets/images/printer_hp_default1.jpg";
import printer_hp_default2 from "../assets/images/printer_hp_default2.jpg";
import printer_hp_default3 from "../assets/images/printer_hp_default3.jpg";
import printer_hp_default4 from "../assets/images/printer_hp_default4.jpg";
import printer_hp_default5 from "../assets/images/printer_hp_default5.jpg";
import printer_hp_default6 from "../assets/images/printer_hp_default6.jpg";
import printer_hp_default7 from "../assets/images/printer_hp_default7.jpg";
import printer_hp_default8 from "../assets/images/printer_hp_default8.jpg";
import printer_canon_default1 from "../assets/images/printer_canon_default1.jpg";
import printer_canon_default2 from "../assets/images/printer_canon_default2.jpg";
import printer_canon_default3 from "../assets/images/printer_canon_default3.jpg";
import printer_canon_default4 from "../assets/images/printer_canon_default4.jpg";
import printer_canon_default5 from "../assets/images/printer_canon_default5.jpg";
import printer_canon_default6 from "../assets/images/printer_canon_default6.jpg";
import printer_canon_default7 from "../assets/images/printer_canon_default7.jpg";
import printer_epson_default1 from "../assets/images/printer_epson_default1.jpg";
import printer_epson_default2 from "../assets/images/printer_epson_default2.jpg";
import printer_epson_default3 from "../assets/images/printer_epson_default3.jpg";
import printer_epson_default4 from "../assets/images/printer_epson_default4.jpg";
import printer_epson_default5 from "../assets/images/printer_epson_default5.jpg";


import homeappliance_xiaomi_default1 from "../assets/images/homeappliance_xiaomi_default1.jpg";
import homeappliance_xiaomi_default2 from "../assets/images/homeappliance_xiaomi_default2.jpg";
import homeappliance_xiaomi_default3 from "../assets/images/homeappliance_xiaomi_default3.jpg";
import homeappliance_xiaomi_default4 from "../assets/images/homeappliance_xiaomi_default4.jpg";
import homeappliance_xiaomi_default5 from "../assets/images/homeappliance_xiaomi_default5.jpg";
import homeappliance_padbot_default1 from "../assets/images/homeappliance_padbot_default1.jpg";
import homeappliance_padbot_default2 from "../assets/images/homeappliance_padbot_default2.jpg";


import laptopBanner from "../assets/images/category_laptop.jpg";
import desktopBanner from "../assets/images/category_desktop.jpg";
import pcComponentkBanner from "../assets/images/category_pccomponents.jpg";
import dmsBanner from "../assets/images/category_dms.jpg";
import wearablesBanner from "../assets/images/category_wearables.jpg";
import networkingBanner from "../assets/images/category_networking.jpg";
import printerBanner from "../assets/images/category_printer.jpg";
import homeApplianceBanner from "../assets/images/category_homeappliance.jpg";

export type Product = {
  id: number;
  brand: string;
  category: string;
  imgSrc: string;
  title: string;
  price: string;
  badge?: string;
  description?: string;
};

export type CategoryBanner = {
  image: string;
};


export const categoryBanners: Record<string, CategoryBanner> = {
    laptop: {
        image: laptopBanner,
    },
    desktop: {
        image: desktopBanner,
    },
    pccomponents: {
        image: pcComponentkBanner,
    },
    dms: {
        image: dmsBanner,
    },
    wearables: {
        image: wearablesBanner,
    },
    networking: {
        image: networkingBanner,
    },
    printer: {
        image: printerBanner,
    },
    homeappliance: {
        image: homeApplianceBanner,
    },
};

export const allProducts: Product[] = [
    // laptop - START
    {
        id: 101,
        brand: "Acer",
        category: "laptop",
        imgSrc: acer_default,
        title: 'Acer Aspire Lite 15 AL15-32P-C6X3 15.6" FHD Laptop Pure Silver ( N4500, 8GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 1,529",
        badge: "New",
    },
    {
        id: 102,
        brand: "Acer",
        category: "laptop",
        imgSrc: acer_default1,
        title: 'Acer Aspire Lite 15 AL15-46P-R8LD 15.6" FHD Laptop Light Silver ( R3-5400U, 8GB, 512GB SSD, ATI, W11, HS+M365 )',
        price: "RM 1,739",
    },
    {
        id: 103,
        brand: "Acer",
        category: "laptop",
        imgSrc: acer_default2,
        title: 'Acer Aspire Lite 15 AL15-42P-R4FV 15.6" FHD Laptop Pure Silver ( R7-7730U, 16GB, 512GB SSD, ATI, W11, HS+M365 )',
        price: "RM 2,369",
        badge: "Hot",
    },
    {
        id: 104,
        brand: "Acer",
        category: "laptop",
        imgSrc: acer_default2,
        title: 'Acer Aspire Lite 16 AL16-53P-55WM 16" WUXGA Laptop Pure Silver ( CU5-115U, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 2,469",
    },
    {
        id: 105,
        brand: "Acer",
        category: "laptop",
        imgSrc: acer_default2b,
        title: 'Acer Swift Go 14 SFG14-72T-76T6 14" WUXGA Touch Laptop Pure Silver  ( CU7-155H, 16GB, 1TB SSD, Intel Arc, W11, HS+M365 )',
        price: "RM 4,999",
        badge: "Featured",
    },
    {
        id: 106,
        brand: "Acer",
        category: "laptop",
        imgSrc: acer_default3,
        title: 'Acer Nitro V 15 ANV15-41-R0DZ 15.6" FHD 165Hz Gaming Laptop (R5 6600H, 8GB, 512GB SSD, RTX 3050 6GB, W11, HS+M365 )',
        price: "RM 2,839",
    },
    {
        id: 107,
        brand: "Acer",
        category: "laptop",
        imgSrc: acer_default4,
        title: 'Acer Nitro V16s AI ANV16S-41-R9W8 16" WUXGA 180Hz Laptop (NVIDIA® GeForce RTX™ 5060, R7-260, 16GB, 1TB SSD, W11, HS)',
        price: "RM 5,619",
    },
    {
        id: 108,
        brand: "Acer",
        category: "laptop",
        imgSrc: acer_default3,
        title: 'Acer Nitro V 15 ANV15-52-50XL 15.6" FHD 165Hz Gaming Laptop (C5-210H, 16GB, 512GB SSD, RTX3050 6GB, W11, HS+M365)',
        price: "RM 3,309",
    },
    {
        id: 109,
        brand: "Acer",
        category: "laptop",
        imgSrc: acer_default5,
        title: 'Acer Predator Triton 14 Ai PT14-52T-93NP 14.5" WQXGA 120Hz Laptop (NVIDIA® GeForce RTX™ 5070, CU9 288V, 32GB, 2TB, W11, HS)',
        price: "RM 12,029",
    },
    {
        id: 110,
        brand: "Lenovo",
        category: "laptop",
        imgSrc: lenovo_default,
        title: 'Lenovo ThinkPad E14 Gen 7 21T0005QMA 14" WUXGA Laptop Black ( R5-220, 16GB, 512GB SSD, ATI, W11P )',
        price: "RM 3,469",
        },
    {
        id: 111,
        brand: "Lenovo",
        category: "laptop",
        imgSrc: lenovo_default1,
        title: 'Lenovo Legion 5 15IAX10 83F0008QMJ 15.1" WQXGA 165Hz Gaming Laptop Eclipse Black ( CU9-275HX, 32GB, 1TB SSD, RTX 5070 8GB, W11 )',
        price: "RM 8,349",
        badge: "On Sale",
    },
    {
        id: 112,
        brand: "Lenovo",
        category: "laptop",
        imgSrc: lenovo_default1,
        title: 'Lenovo Legion 5 15IAX10 83F0008RMJ 15.1" WQXGA 165Hz Gaming Laptop Eclipse Black ( CU7-255HX, 16GB, 1TB SSD, RTX 5060 8GB, W11 )',
        price: "RM 6,939",
    },
    {
        id: 113,
        brand: "Lenovo",
        category: "laptop",
        imgSrc: lenovo_default2,
        title: 'Lenovo Legion Pro 7 16IAX10H 83F500JEMJ 16" WQXGA 240Hz Gaming Laptop ( CU9-275HX, 32GB, 1TB SSD, RTX5070Ti 12GB, W11 )',
        price: "RM 13,339",
        badge: "Popular",
    },
    {
        id: 114,
        brand: "Lenovo",
        category: "laptop",
        imgSrc: lenovo_default3,
        title: 'Lenovo IdeaPad 1 15AMN7 82VG00YDMJ 15.6" HD Laptop Cloud Grey ( Athlon 7120U, 8GB, 512GB SSD, ATI, W11, HS+M365 )',
        price: "RM 1,609",
    },
    {
        id: 115,
        brand: "Lenovo",
        category: "laptop",
        imgSrc: lenovo_default4,
        title: 'Lenovo Yoga 7 14IML9 83DJ00JPMJ 14" WUXGA OLED 2-in-1 Touch Laptop Tidal Teal ( CU5 125H, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 3,629",
    },
    {
        id: 116,
        brand: "Lenovo",
        category: "laptop",
        imgSrc: lenovo_default5,
        title: 'Lenovo LOQ 15AHP10 83JG00AVMJ 15.6" FHD 144Hz Gaming Laptop Luna Grey ( R7-250, 16GB, 512GB SSD, RTX5060 8GB, W11, HS )',
        price: "RM 4,839",
    },
    {
        id: 117,
        brand: "Lenovo",
        category: "laptop",
        imgSrc: lenovo_default6,
        title: 'Lenovo IdeaPad Slim 3 15IAN8 82XB00J1MJ 15.6" FHD Laptop Arctic Grey ( N100, 8GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 1,519",
    },
    {
        id: 118,
        brand: "Lenovo",
        category: "laptop",
        imgSrc: lenovo_default7,
        title: 'Lenovo IdeaPad Slim 3 15IRU8 82X700KCMJ 15.6" FHD Laptop Abyss Blue (U300, 8GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 1,789",
    },
    {
        id: 119,
        brand: "Asus",
        category: "laptop",
        imgSrc: asus_default,
        title: 'Asus ProArt PX13 OLED HN7306E-ALX066WS 13.3" 3K Touch Laptop Nano Black ( AI MAX+ 395, 64GB, 1TB SSD, ATI, W11, HS+M365 )',
        price: "RM 11,349",
        badge: "New",
    },
    {
        id: 120,
        brand: "Asus",
        category: "laptop",
        imgSrc: asus_default1,
        title: 'Asus VivoBook S 16 M3607G-ASH646WS 16" WUXGA OLED 60Hz Laptop Cool Silver ( Ryzen AI 7 445, 16GB, 512GB, ATI, W11, HS+M365 )',
        price: "RM 4,599",
        badge: "New",
    },
    {
        id: 121,
        brand: "Asus",
        category: "laptop",
        imgSrc: asus_default2,
        title: 'Asus VivoBook S 16 M3607G-ASH645WS 16" WUXGA OLED 60Hz Laptop Matte Gray ( Ryzen AI 7 445, 16GB, 512GB, ATI, W11, HS+M365 )',
        price: "RM 4,599",
        badge: "New",
    },
    {
        id: 122,
        brand: "Asus",
        category: "laptop",
        imgSrc: asus_default3,
        title: 'Asus Vivobook 16 M1607G-AMB445WS 16" WUXGA Laptop Quiet Blue ( Ryzen AI 7 445, 16GB, 1TB SSD, ATI, W11, HS+M365 )',
        price: "RM 4,209",
        badge: "New",
    },
    {
        id: 123,
        brand: "Asus",
        category: "laptop",
        imgSrc: asus_default4,
        title: 'Asus Zenbook 14 UX3405C-AQL248WS 14" WUXGA OLED Laptop Ponder Blue ( CU5-225H, 16GB, 512B SSD, Intel Arc, W11, HS+M365 )',
        price: "RM 4,419",
        badge: "New",
    },
    {
        id: 124,
        brand: "Asus",
        category: "laptop",
        imgSrc: asus_default5,
        title: 'Asus VivoBook Go 15 E1504F-ABQ052WS 15.6" FHD Laptop Green Grey ( R5 40, 16GB, 512GB SSD, ATI, W11, HS+M365 )',
        price: "RM 2,479",
        badge: "New",
    },
    {
        id: 125,
        brand: "Asus",
        category: "laptop",
        imgSrc: asus_default6,
        title: 'Asus VivoBook Go 15 E1504F-ABQ050WS 15.6" FHD Laptop Mixed Black ( R5 40, 16GB, 512GB SSD, ATI, W11, HS+M365 )',
        price: "RM 2,479",
        badge: "New",
    },
    {
        id: 126,
        brand: "Asus",
        category: "laptop",
        imgSrc: asus_default7,
        title: 'Asus ROG Flow Z13-KJP GZ302E-ACRU188W 13.4" 2.5K 180Hz Gaming Laptop ( AI MAX+ 395, 128GB, 1TB SSD, ATI, W11 )',
        price: "RM 17,329",
        badge: "On Sale",
    },
    {
        id: 127,
        brand: "Asus",
        category: "laptop",
        imgSrc: asus_default8,
        title: 'Asus TUF Gaming A14 FA401E-ARG026W 14" 2.5K 165Hz Gaming Laptop ( AI MAX+ 392, 32GB, 1TB SSD, ATI, W11 )',
        price: "RM 7,299",
        badge: "On Sale",
    },
    {
        id: 128,
        brand: "MSI",
        category: "laptop",
        imgSrc: msi_default,
        title: 'MSI Prestige 14 AI+ D3MG-064 14" FHD+ OLED Laptop Platinum Gray ( CU7-355, 32GB, 1TB SSD, Intel, W11, H&S )',
        price: "RM 5,899",
        badge: "Hot",
    },
    {
        id: 129,
        brand: "MSI",
        category: "laptop",
        imgSrc: msi_default1,
        title: 'MSI Prestige 13 AI+ A3MG-034 13.3" 2.8K OLED Laptop Platinum Gray ( CU7-355, 32GB, 1TB SSD, Intel, W11, H&S )',
        price: "RM 6,299",
        badge: "Top Pick",
    },
    {
        id: 130,
        brand: "MSI",
        category: "laptop",
        imgSrc: msi_default2,
        title: 'MSI Thin 15 B13UC-3456 15.6" FHD Gaming Laptop Cosmos Gray ( i5-13420H, 16GB, 512GB SSD, RTX3050 4GB, W11, HS+M365 )',
        price: "RM 3,579",
        badge: "On Sale",
    },
    {
        id: 131,
        brand: "MSI",
        category: "laptop",
        imgSrc: msi_default3,
        title: 'MSI Thin 15 B13UC-3439 15.6" FHD Gaming Laptop Cosmos Gray ( i7-13620H, 16GB, 512GB SSD, RTX3050 4GB, W11, HS )',
        price: "RM 3,789",
    },
    {
        id: 132,
        brand: "MSI",
        category: "laptop",
        imgSrc: msi_default4,
        title: 'MSI Thin 15 B13UC-3441 15.6" FHD Gaming Laptop Cosmos Gray ( i5-13420H, 16GB, 512GB SSD, RTX3050 4GB, W11 )',
        price: "RM 3,519",
    },
    {
        id: 133,
        brand: "MSI",
        category: "laptop",
        imgSrc: msi_default5,
        title: '(AS New) MSI Thin A15 B7UC-204 15.6" FHD Gaming Laptop Cosmos Gray ( Ryzen 7 7735HS, 8GB D5, 512GB SSD, RTX3050 4GB, W11 )',
        price: "RM 3,259",
    },
    {
        id: 134,
        brand: "MSI",
        category: "laptop",
        imgSrc: msi_default6,
        title: 'MSI Thin A15 B7UC-647 15.6" FHD Gaming Laptop Cosmos Gray ( R7-7735HS, 16GB D5, 1TB SSD, RTX3050 4GB, W11 )',
        price: "RM 3,889",
    },
    {
        id: 135,
        brand: "MSI",
        category: "laptop",
        imgSrc: msi_default7,
        title: 'MSI Cyborg 15 B13WFKG-680 15.6" FHD Gaming Laptop ( i7-13620H, 16GB, 1TB SSD, RTX5060 8GB, W11 )',
        price: "RM 5,519",
    },
    {
        id: 136,
        brand: "MSI",
        category: "laptop",
        imgSrc: msi_default8,
        title: 'MSI Cyborg 15 B13WFKG-680 15.6" FHD Gaming Laptop ( i7-13620H, 16GB, 1TB SSD, RTX5060 8GB, W11 )',
        price: "RM 4,679",
    },
    {
        id: 137,
        brand: "HP",
        category: "laptop",
        imgSrc: hp_default,
        title: 'HP OmniBook 7 AI 14-fr0070/0071/0072TU 14" 2K Laptop (CU7-255U, 16GB, 512GB SSD, Intel, W11, HS+M365)',
        price: "RM 4,449",
        badge: "New",
    },
    {
        id: 138,
        brand: "HP",
        category: "laptop",
        imgSrc: hp_default1,
        title: 'HP 15-fd2120TU 15.6" FHD Laptop Natural Silver ( CU7-255U, 16GB, 512GB SSD, Intel , W11, HS+M365 )',
        price: "RM 3,309",
    },
    {
        id: 139,
        brand: "HP",
        category: "laptop",
        imgSrc: hp_default2,
        title: 'HP 15-fd2119TU 15.6" FHD Laptop Moonlight Blue ( CU7-255U, 16GB, 512GB SSD, Intel , W11, HS+M365 )',
        price: "RM 3,309",
    },
    {
        id: 140,
        brand: "HP",
        category: "laptop",
        imgSrc: hp_default3,
        title: 'HP AI 15-fd2118TU 15.6" FHD Laptop Warm Gold ( CU7-255U, 16GB, 512GB SSD, Intel , W11, HS+M365 )',
        price: "RM 3,309",
    },
    {
        id: 141,
        brand: "HP",
        category: "laptop",
        imgSrc: hp_default4,
        title: 'HP PROBOOK 4 G1i-BV5X8PT 14" WUXGA Notebook AI Pike silver ( CU5 225U, 16GB, 512 GB SSD, Intel, W11P )',
        price: "RM 4,729",
        badge: "Hot",
    },
    {
        id: 142,
        brand: "HP",
        category: "laptop",
        imgSrc: hp_default5,
        title: 'HP 15-fd0907TU 15.6" FHD Laptop Natural Silver ( C5-120U, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 2,419",
    },
    {
        id: 143,
        brand: "HP",
        category: "laptop",
        imgSrc: hp_default6,
        title: 'HP 15-fd0906TU 15.6" FHD Laptop Moonlight Blue ( C5-120U, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 2,419",
        badge: "On Sale",
    },
    {
        id: 144,
        brand: "HP",
        category: "laptop",
        imgSrc: hp_default7,
        title: 'HP 15-fd0905TU 15.6" FHD Laptop Warm Gold ( C5-120U, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 2,419",
    },
    {
        id: 145,
        brand: "HP",
        category: "laptop",
        imgSrc: hp_default8,
        title: 'HP OmniBook 3 NGAI 14-ha0023AU 14" FHD Laptop Glacier Silver ( AI 5 330, 24GB, 512GB SSD, ATI, W11, HS+M365 )',
        price: "RM 2,949",
    },
    {
        id: 146,
        brand: "Dell",
        category: "laptop",
        imgSrc: dell_default,
        title: 'Dell 14PRO PC14255-R7350-16G-512G-3YRS 14" FHD+ Laptop Silver ( AI 7-350, 16GB D5, 512GB SSD, ATI, W11P )',
        price: "RM 4,149",
    },
    {
        id: 147,
        brand: "Dell",
        category: "laptop",
        imgSrc: dell_default1,
        title: 'Dell 14PRO PC14255-R5220-16G-512GB-3YRS 14" FHD+ Laptop Silver ( R5-220, 16GB D5, 512GB SSD, ATI, W11P )',
        price: "RM 3,419",
    },
    {
        id: 148,
        brand: "Dell",
        category: "laptop",
        imgSrc: dell_default2,
        title: 'Dell 14PRO PV14250-C5120U-8G-512-W11PRO 14" FHD+ Laptop Black ( C5-120U, 8GB D5, 512GB SSD, Intel, W11P )',
        price: "RM 2,789",
    },
    {
        id: 149,
        brand: "Dell",
        category: "laptop",
        imgSrc: dell_default3,
        title: '(AS NEW) Dell XPS14-9440-55165-RTX4050-W11PRO-2YRS 14.5" 3K OLED+ Laptop Silver ( CU7-165H, 16GB, 512GB, RTX4050 6GB , W11P )',
        price: "RM 6,829",
    },
    {
        id: 150,
        brand: "Dell",
        category: "laptop",
        imgSrc: dell_default4,
        title: 'Dell Precision 3590 Workstation M3590-U7155H-16G-512GB 15.6" FHD IPS Laptop  ( CU7 155H, 16GB, 512GB, Intel, W11P )',
        price: "RM 4,519",
    },
    {
        id: 151,
        brand: "Dell",
        category: "laptop",
        imgSrc: dell_default5,
        title: 'Dell 15 DC15255-R77730U-16GB-512GB-W11H 15.6" FHD IPS Laptop Platinum Silver ( R7 7730U, 16GB, 512GB, ATI, W11,HS+M365 )',
        price: "RM 2,679",
    },
    {
        id: 152,
        brand: "Dell",
        category: "laptop",
        imgSrc: dell_default6,
        title: 'Dell 16 DC16250-C5120U-16GB-512GB-W11H 16" FHD 2K IPS Laptop Carbon Black ( C5-120U, 16GB, 512GB, Intel, W11,HS+M365 )',
        price: "RM 2,679",
    },
    {
        id: 153,
        brand: "Dell",
        category: "laptop",
        imgSrc: dell_default7,
        title: 'Dell 16 DC16250-C7150U-16GB-1TB-W11H 16" FHD 2K IPS Laptop Carbon Black ( C7-150U, 16GB, 1TB, Intel, W11,HS+M365 )',
        price: "RM 3,259",
    },
    {
        id: 154,
        brand: "Dell",
        category: "laptop",
        imgSrc: dell_default8,
        title: 'Dell PC14250-C7150U-16G-512GB 14" FHD+ Touch Laptop ( C7-150U, 16GB D5, 512GB SSD, Intel, W11P )',
        price: "RM 4,149",
    },
    {
        id: 155,
        brand: "Apple",
        category: "laptop",
        imgSrc: apple_default,
        title: 'Apple MacBook Pro 14.2" Laptop ( Apple M4 Pro chip, 24GB, 512GB, MacOS ) MX2H3ZP, MX2E3ZP',
        price: "RM 8,249",
        badge: "Top Pick",
    },
    {
        id: 156,
        brand: "Apple",
        category: "laptop",
        imgSrc: apple_default1,
        title: 'Apple MacBook Pro 16.2" Laptop ( Apple M4 Max chip, 48GB, 1TB, MacOS ) MX313ZP, MX2W3ZP',
        price: "RM 17,329",
    },
    {
        id: 157,
        brand: "Apple",
        category: "laptop",
        imgSrc: apple_default2,
        title: 'Apple MacBook Pro 16.2" Laptop ( Apple M4 Pro chip, 24GB, 512GB, MacOS ) MX2X3ZP, MX2T3ZP',
        price: "RM 10,719",
    },
    {
        id: 158,
        brand: "Apple",
        category: "laptop",
        imgSrc: apple_default3,
        title: 'Apple MacBook Air 15.3" Laptop ( Apple M3 chip, 16GB, 256GB, MacOS ) MC9D4ZP, MC9E4ZP',
        price: "RM 5,049",
        badge: "Hot",
    },
    {
        id: 159,
        brand: "Apple",
        category: "laptop",
        imgSrc: apple_default4,
        title: 'Apple MacBook Air 13.6" Laptop ( Apple M4 chip, 16GB, 256GB, MacOS ) MC6T4ZP, MW0W3ZP, MW0Y3ZP, MW123ZP',
        price: "RM 4,309",
    },
    {
        id: 160,
        brand: "Apple",
        category: "laptop",
        imgSrc: apple_default5,
        title: 'Apple iPad Air 11" Wi-Fi 512GB Gen 6 ( MCA94ZP, MCAE4ZP, MCAA4ZP, MCA74ZP ) - M3 Chip',
        price: "RM 3,999",
    },
    {
        id: 161,
        brand: "Apple",
        category: "laptop",
        imgSrc: apple_default6,
        title: 'Apple iPad Air 11" Wi-Fi 256GB Gen 6 ( MCA34ZP, MCA64ZP, MCA44ZP, MCA14ZP ) - M3 Chip',
        price: "RM 3,049",
    },
    {
        id: 162,
        brand: "Apple",
        category: "laptop",
        imgSrc: apple_default7,
        title: 'Apple iPad 11" Wi-Fi 256GB Gen 11 ( MD4G4ZP, MD4H4ZP, MD4J4ZP, MD4P4ZP ) - A16 Chip',
        price: "RM 1,899",
    },
    {
        id: 163,
        brand: "Apple",
        category: "laptop",
        imgSrc: apple_default8,
        title: 'Apple iPad 11" Wi-Fi 128GB Gen 11 ( MD3Y4ZP, MD4A4ZP, MD4D4ZP, MD4E4ZP ) - A16 Chip',
        price: "RM 1,419",
    },
    // laptop - END

    
    // desktop - START
    {
        id: 201,
        brand: "Acer",
        category: "desktop",
        imgSrc: desktop_acer_default1,
        title: 'Acer Aspire TC1860-225W11 Desktop PC Black ( CU5-225, 8GB, 512GB SSD, Intel, W11 )',
        price: "RM 2,349",
    },
    {
        id: 202,
        brand: "Acer",
        category: "desktop",
        imgSrc: desktop_acer_default2,
        title: 'Acer Veriton Vero Mini VN4720GT-51448PS Desktop PC Window ( i5-14400, 8GB, 512GB SSD, Intel, W11P )',
        price: "RM 3,369",
    },
    {
        id: 203,
        brand: "Acer",
        category: "desktop",
        imgSrc: desktop_acer_default3,
        title: 'Acer Nitro N50-660-265W11 Gaming Desktop PC ( CU7-265F, 16GB, 512GB SSD, RTX5060 8GB, W11 )',
        price: "RM 4,989",
    },
    {
        id: 204,
        brand: "Acer",
        category: "desktop",
        imgSrc: desktop_acer_default4,
        title: 'Acer Aspire XC1860-265W11S Desktop PC Black ( CU7-265, 8GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 3,889",
    },
    {
        id: 205,
        brand: "Acer",
        category: "desktop",
        imgSrc: desktop_acer_default5,
        title: 'Acer Aspire XC1785-14400W11S Desktop PC Black ( i5-14400, 8GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 2,319",
    },
    {
        id: 206,
        brand: "Acer",
        category: "desktop",
        imgSrc: desktop_acer_default6,
        title: 'Acer Aspire XC1785-14700W11 Desktop PC Black ( i7-14700, 8GB, 512GB SSD, Intel, W11, HS )',
        price: "RM 3,159",
    },
    {
        id: 207,
        brand: "Asus",
        category: "desktop",
        imgSrc: desktop_asus_default1,
        title: 'Asus AIO V470VA-TBPF050WS 27&quot; FHD All-In-One Desktop PC Black ( C5-210H, 16GB, 512GB, Intel, W11, HS+M365 )',
        price: "RM 4,149",
    },
    {
        id: 208,
        brand: "Asus",
        category: "desktop",
        imgSrc: desktop_asus_default2,
        title: 'Asus AIO V470VA-TWPF020WS 27&quot; FHD All-In-One Desktop PC White ( C5-210H, 16GB, 512GB, Intel, W11, HS+M365 )',
        price: "RM 4,149",
    },
    {
        id: 209,
        brand: "Asus",
        category: "desktop",
        imgSrc: desktop_asus_default3,
        title: 'Asus ROG G700TF-7265KF279W Gaming Desktop PC ( CU7-265KF, 32GB, 1TB SSD, NV RTX 5070 12GB, W11 )',
        price: "RM 10,509",
    },
    {
        id: 210,
        brand: "Asus",
        category: "desktop",
        imgSrc: desktop_asus_default4,
        title: 'Asus TUF T500MV-05210H283W Gaming Desktop PC ( C5-210H, 16GB, 512GB SSD, NV RTX3050 6GB, W11 )',
        price: "RM 3,679",
    },
    {
        id: 211,
        brand: "Asus",
        category: "desktop",
        imgSrc: desktop_asus_default5,
        title: 'Asus Vivo AIO A3402WV-AKBPC098WS 23.8&quot; FHD All-In-One Desktop PC Black ( i3-1315U, 8GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 2,319",
    },
    {
        id: 212,
        brand: "Dell",
        category: "desktop",
        imgSrc: desktop_dell_default1,
        title: 'Dell Pro Slim QCS1255-R58500G-8GB-512GB-W11PRO Desktop PC ( R5-8500G, 8GB, 512GB SSD, ATI, W11P )',
        price: "RM 2,789",
    },
    {
        id: 213,
        brand: "Dell",
        category: "desktop",
        imgSrc: desktop_dell_default2,
        title: 'Dell Pro Micro QCM1255-R58500GE-8GB-512GB-W11PRO Desktop PC ( R5-8500GE, 8GB, 512GB SSD, ATI, W11P )',
        price: "RM 2,629",
    },
    {
        id: 214,
        brand: "Dell",
        category: "desktop",
        imgSrc: desktop_dell_default3,
        title: 'Dell ECT1250-i514400-8G-512GB Tower Desktop PC ( i5-14400, 8GB, 512GB SSD, Intel, W11P )',
        price: "RM 2,999",
    },
    {
        id: 215,
        brand: "HP",
        category: "desktop",
        imgSrc: desktop_hp_default1,
        title: 'HP OmniStudio X NGAI 27-cs1008D 27&quot; FHD Touch All-in-One Desktop PC ( CU7-256V, 16GB, 1TB SSD, Intel Arc, W11, H&S+M365 )',
        price: "RM 5,359",
    },
    {
        id: 216,
        brand: "HP",
        category: "desktop",
        imgSrc: desktop_hp_default2,
        title: 'HP OmniStudio 24-cu0001D 23.8&quot; FHD All-in-One Desktop PC Cotton White ( C5-210H, 16GB, 512GB SSD, Intel, W11, H&S+M365 )',
        price: "RM 3,549",
    },
    {
        id: 217,
        brand: "HP",
        category: "desktop",
        imgSrc: desktop_hp_default3,
        title: 'HP OMEN TG03-0017D 16L Gaming Desktop PC Black Metal ( i5-14400F, 16GB, 512GB SSD, RTX5060 8GB, W11 )',
        price: "RM 4,699",
    },
    {
        id: 218,
        brand: "HP",
        category: "desktop",
        imgSrc: desktop_hp_default4,
        title: 'HP OmniDesk M03-0027D Dark Wood Desktop AI ( CU7 265, 16GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 3,599",
    },
    {
        id: 219,
        brand: "Xiaomi",
        category: "desktop",
        imgSrc: desktop_xiaomi_default1,
        title: 'Xiaomi A27Ui 27" 4K IPS 60Hz Monitor ( HDMI, DP, USB-C, 3 Yrs Wrty )',
        price: "RM 919",
    },
    {
        id: 220,
        brand: "Xiaomi",
        category: "desktop",
        imgSrc: desktop_xiaomi_default2,
        title: 'Xiaomi G27Qi 27" 2K Fast IPS 180Hz Gaming Monitor ( HDMI, DP, 3 Yrs Wrty )',
        price: "RM 689",
    },
    {
        id: 221,
        brand: "Xiaomi",
        category: "desktop",
        imgSrc: desktop_xiaomi_default3,
        title: 'Xiaomi A27Qi 27" 2K IPS 100Hz Monitor ( HDMI, DP, 3 Yrs Wrty )',
        price: "RM 499",
    },
    {
        id: 222,
        brand: "Xiaomi",
        category: "desktop",
        imgSrc: desktop_xiaomi_default4,
        title: 'Xiaomi G34WQi 34" WQHD 180Hz Curved Gaming Monitor ( HDMI, DP, 3 Yrs Wrty )',
        price: "RM 1,119",
    },
    {
        id: 223,
        brand: "Samsung",
        category: "desktop",
        imgSrc: desktop_samsung_default1,
        title: 'Samsung M8 M80F AI LS32FM803UEXXS  32" 4K 60Hz VA Smart Monitor ( HDMI, USB-C, USB Hub, 3 Yrs Wrty )',
        price: "RM 2,789",
    },
    {
        id: 224,
        brand: "Samsung",
        category: "desktop",
        imgSrc: desktop_samsung_default2,
        title: 'Samsung Odyssey G3 G30D LS27DG302EEXXS  27" FHD 180Hz VA Gaming Monitor ( DP, HDMI, 3 Yrs Wrty )',
        price: "RM 549",
    },
    {
        id: 225,
        brand: "Lenovo",
        category: "desktop",
        imgSrc: desktop_lenovo_default1,
        title: 'Lenovo IdeaCentre Tower 08IRH9 90XW005KMI Desktop PC Cloud Grey ( i7-13620H, 8GB, 512GB SSD, Intel, W11, HS+M365 )',
        price: "RM 3,119",
    },
    {
        id: 226,
        brand: "Lenovo",
        category: "desktop",
        imgSrc: desktop_lenovo_default2,
        title: 'Lenovo ThinkCentre M70t G6-01ME 12YM0001ME Tower Desktop PC Black ( CU5-225, 8GB, 512GB SSD, Intel, W11P )',
        price: "RM 3,419",
    },
    {
        id: 227,
        brand: "Lenovo",
        category: "desktop",
        imgSrc: desktop_lenovo_default3,
        title: 'Lenovo Legion T5 301AS10 90YA007MMP Gaming Desktop PC ( CU5 225F, 16GB, 512GB SSD, NV RTX5060 Ti 8GB, W11 )',
        price: "RM 5,679",
    },
    {
        id: 228,
        brand: "Lenovo",
        category: "desktop",
        imgSrc: desktop_lenovo_default4,
        title: 'Lenovo IdeaCentre AIO 24ARR9 F0HR009XMI 23.8" FHD Touch All-in-One Desktop PC ( R7-7735HS, 16GB, 512GB SSD, ATI, W11, HS+M365 )',
        price: "RM 3,129",
    },
    {
        id: 229,
        brand: "Lenovo",
        category: "desktop",
        imgSrc: desktop_lenovo_default5,
        title: 'Lenovo ThinkCentre M70t 12U0001GME Tower Desktop PC Black ( i7-14700, 16GB, 512GB SSD, Intel, W11P )',
        price: "RM 3,999",
    },
    {
        id: 230,
        brand: "MSI",
        category: "desktop",
        imgSrc: desktop_msi_default1,
        title: 'MSI PRO MP275 E14L 27" FHD IPS 144Hz Flat Monitor ( Speaker, HDMI, D-Sub, 3Yrs Warranty )',
        price: "RM 369",
    },
    {
        id: 231,
        brand: "MSI",
        category: "desktop",
        imgSrc: desktop_msi_default2,
        title: 'MSI MAG 273QP QD-OLED X24 26.5" WQHD 240Hz Flat Gaming Monitor ( DP, HDMI, 3 Yrs Warranty )',
        price: "RM 2,069",
    },
    {
        id: 232,
        brand: "MSI",
        category: "desktop",
        imgSrc: desktop_msi_default3,
        title: 'MSI Optix MAG 322URDF E16 31.5" UHD 160Hz Flat Gaming Monitor ( DP, HDMI, 3Yrs Warranty )',
        price: "RM 1,839",
    },
    {
        id: 233,
        brand: "MSI",
        category: "desktop",
        imgSrc: desktop_msi_default4,
        title: 'MSI Pro MP2412 23.8" FHD 100Hz Flat Monitor Black ( HDMI, DisplayPort, 3Yrs Warranty )',
        price: "RM 299",
    },
    // desktop - END


    // pccomponents - START
    {
        id: 301,
        brand: "Air Cooler",
        category: "pccomponents",
        imgSrc: pccomponents_ac_default1,
        title: 'DEEPCOOL ASSASIN IV TOWER COOLER (R-ASN4-BKNNMT-G)',
        price: "RM 449",
    },
    {
        id: 302,
        brand: "Air Cooler",
        category: "pccomponents",
        imgSrc: pccomponents_ac_default2,
        title: 'DEEPCOOL AK620 WHITE DUAL TOWER (R-AK620-WHNNMT-G-1)',
        price: "RM 315",
    },
    {
        id: 303,
        brand: "Air Cooler",
        category: "pccomponents",
        imgSrc: pccomponents_ac_default3,
        title: 'DEEPCOOL AG620 BK ARGB DUAL TOWER CPU COOLER (R-AG620-BKANMN-G-2)',
        price: "RM 239",
    },
    {
        id: 304,
        brand: "Air Cooler",
        category: "pccomponents",
        imgSrc: pccomponents_ac_default4,
        title: 'Cooler Master Hyper 212 LED Cooling / Cooler For Intel AMD Socket ( RR-212L-16PR-R1, Black )',
        price: "RM 209",
    },
    {
        id: 305,
        brand: "Air Cooler",
        category: "pccomponents",
        imgSrc: pccomponents_ac_default5,
        title: 'DEEPCOOL AG400 WHITE ARGB SINGLE TOWER CPU COOLER (R-AG400-WHANMC-G-2)',
        price: "RM 129",
    },
    {
        id: 306,
        brand: "Air Cooler",
        category: "pccomponents",
        imgSrc: pccomponents_ac_default6,
        title: 'Cooler Master Standard Cooler i70C CPU Air Cooler with Blue LED (RR-I70C-20PK-R1 / CM-RR-I70C-20PK-R1)',
        price: "RM 89",
    },
    {
        id: 307,
        brand: "Casing",
        category: "pccomponents",
        imgSrc: pccomponents_casing_default1,
        title: 'HYTE Y40 ATX CASE - WHITE (CS-HYTE-Y40-BW)',
        price: "RM 699",
    },
    {
        id: 308,
        brand: "Casing",
        category: "pccomponents",
        imgSrc: pccomponents_casing_default2,
        title: 'HYTE Y40 ATX CASE - SNOW WHITE (CS-HYTE-Y40-WW)',
        price: "RM 669",
    },
    {
        id: 309,
        brand: "Casing",
        category: "pccomponents",
        imgSrc: pccomponents_casing_default3,
        title: 'HYTE Y40 ATX CASE - BLACK (CS-HYTE-Y40-B)',
        price: "RM 669",
    },
    {
        id: 310,
        brand: "Casing",
        category: "pccomponents",
        imgSrc: pccomponents_casing_default4,
        title: 'Corsair 5000D Airflow TG Mid-Tower ATX PC Case / 2 Fans',
        price: "RM 585",
    },
    {
        id: 311,
        brand: "Casing",
        category: "pccomponents",
        imgSrc: pccomponents_casing_default5,
        title: 'Cooler Master CMP 510 ATX Case, Fine Mesh Front Panel, ARGB Edge at Front Panel, Up to 280mm Radiator Support (CP510-KGNN-S03)',
        price: "RM 309",
    },
    {
        id: 312,
        brand: "Casing",
        category: "pccomponents",
        imgSrc: pccomponents_casing_default6,
        title: 'MSI MPG Sekira 500X Mid Tower Desktop Casing',
        price: "RM 1,069",
    },
    {
        id: 313,
        brand: "Casing",
        category: "pccomponents",
        imgSrc: pccomponents_casing_default7,
        title: 'MSI MPG Sekira 100p Mid Tower Desktop Casing',
        price: "RM 569",
    },
    {
        id: 314,
        brand: "Casing",
        category: "pccomponents",
        imgSrc: pccomponents_casing_default8,
        title: 'MSI MPG Gungnir 110R  ATX Gaming Casing',
        price: "RM 459",
    },
    {
        id: 315,
        brand: "Desktop Bracket",
        category: "pccomponents",
        imgSrc: pccomponents_db_default1,
        title: 'Cooler Master ELV8 GPU Brace RGB Lighting Universal Graphics Card Holder ( MAZ-IMGB-N30NA-R1 / CM-MAZ-IMGB-N30NA-R1 )',
        price: "RM 119",
    },
    {
        id: 316,
        brand: "Desktop Bracket",
        category: "pccomponents",
        imgSrc: pccomponents_db_default2,
        title: 'Cooler Master ARGB GPU Tempered Glass Support Bracket / GPU Holder (MCA-U000R-GSBTG-00)',
        price: "RM 129",
    },
    {
        id: 317,
        brand: "Graphic Card",
        category: "pccomponents",
        imgSrc: pccomponents_gcard_default1,
        title: 'MSI GeForce RTX™ 5070 12G INSPIRE 3X OC Graphic Card',
        price: "RM 3,299",
    },
    {
        id: 318,
        brand: "Graphic Card",
        category: "pccomponents",
        imgSrc: pccomponents_gcard_default2,
        title: 'MSI GeForce RTX™ 5060 8G INSPIRE 2X OC Graphic Card',
        price: "RM 1,599",
    },
    {
        id: 319,
        brand: "Liquid Cooling",
        category: "pccomponents",
        imgSrc: pccomponents_lc_default1,
        title: 'DEEPCOOL LT720 WHITE CPU LIQUID COOLER (R-LT720-WHAMNF-G-1)',
        price: "RM 609",
    },
    {
        id: 320,
        brand: "Liquid Cooling",
        category: "pccomponents",
        imgSrc: pccomponents_lc_default2,
        title: 'ROG Ryujin II 240 All-in-one Liquid CPU Cooler with 3.5&quot; LCD Display (2 Noctua Inustrial PPC radiator fans)',
        price: "RM 1,350",
    },
    {
        id: 321,
        brand: "Liquid Cooling",
        category: "pccomponents",
        imgSrc: pccomponents_lc_default3,
        title: 'Corsair iCUE H100i ELITE LCD Display Liquid CPU Cooler (CW-9060061-WW)',
        price: "RM 1,069",
    },
    {
        id: 322,
        brand: "Liquid Cooling",
        category: "pccomponents",
        imgSrc: pccomponents_lc_default4,
        title: 'MSI MAG CORELIQUID C240 Liquid Cooling',
        price: "RM 529",
    },
    {
        id: 323,
        brand: "Liquid Cooling",
        category: "pccomponents",
        imgSrc: pccomponents_lc_default5,
        title: 'EVGA CLC 280 AIO RGB LED Liquid CPU Cooler',
        price: "RM 599",
    },
    {
        id: 324,
        brand: "Liquid Cooling",
        category: "pccomponents",
        imgSrc: pccomponents_lc_default6,
        title: 'ID-COOLING ZoomFlow 240X ARGB WaterCooling',
        price: "RM 339",
    },
    {
        id: 325,
        brand: "Liquid Cooling",
        category: "pccomponents",
        imgSrc: pccomponents_lc_default7,
        title: 'Cooler Master MasterLiquid ML360R RGB Dual Chamber Pump AIO CPU Liquid Cooler (MLX-D36M-A20PC-R1)',
        price: "RM 599",
    },
    {
        id: 326,
        brand: "Liquid Cooling",
        category: "pccomponents",
        imgSrc: pccomponents_lc_default8,
        title: 'MSI MPG CORELIQUID K240 ARGB AIO Liquid CPU Cooler',
        price: "RM 869",
    },
    {
        id: 327,
        brand: "Motherboard",
        category: "pccomponents",
        imgSrc: pccomponents_motherboard_default1,
        title: 'ASUS TUF GAMING B650-PLUS WIFI MOTHERBOARD (AMD)',
        price: "RM 1,569",
    },
    {
        id: 328,
        brand: "Motherboard",
        category: "pccomponents",
        imgSrc: pccomponents_motherboard_default2,
        title: 'ASUS PRIME B550M-K MOTHERBOARD (AMD)',
        price: "RM 469",
    },
    {
        id: 329,
        brand: "Motherboard",
        category: "pccomponents",
        imgSrc: pccomponents_motherboard_default3,
        title: 'ASUS PRIME B760M-A WIFI D4 MOTHERBOARD',
        price: "RM 829",
    },
    {
        id: 330,
        brand: "Motherboard",
        category: "pccomponents",
        imgSrc: pccomponents_motherboard_default4,
        title: 'MSI MEG Z490 ACE Motherboard (Intel LGA1200)',
        price: "RM 1,969",
    },
    {
        id: 331,
        brand: "Peripherals",
        category: "pccomponents",
        imgSrc: pccomponents_peripherals_default1,
        title: 'Corsair iCUE LC100 Case Accent Lighting Panels - Mini Triangle - 9x Tile Starter Kit (CL-9011114-WW)',
        price: "RM 669",
    },
    {
        id: 332,
        brand: "Peripherals",
        category: "pccomponents",
        imgSrc: pccomponents_peripherals_default2,
        title: 'Corsair Icue Ll120 3 Fan Pack With Lightning Node Pro Case Fan - Black (CO-9050072-WW)',
        price: "RM 399",
    },
    {
        id: 333,
        brand: "Peripherals",
        category: "pccomponents",
        imgSrc: pccomponents_peripherals_default3,
        title: 'Logitech MK240 Nano Wireless Keyboard Mouse Combo',
        price: "RM 99",
    },
    {
        id: 334,
        brand: "Peripherals",
        category: "pccomponents",
        imgSrc: pccomponents_peripherals_default4,
        title: 'Thermaltake TTesport Meka Pro Mechanical Gaming Keyboard (Cherry Blue)',
        price: "RM 499",
    },
    {
        id: 335,
        brand: "Peripherals",
        category: "pccomponents",
        imgSrc: pccomponents_peripherals_default5,
        title: 'Thermaltake TTesport Iris Optical RGB Gaming Mouse',
        price: "RM 169",
    },
    {
        id: 336,
        brand: "Power Supply",
        category: "pccomponents",
        imgSrc: pccomponents_powersupply_default1,
        title: 'MSI MPG A850G PCIE5 850W 80 Plus Gold Power Supply',
        price: "RM 869",
    },
    {
        id: 337,
        brand: "Power Supply",
        category: "pccomponents",
        imgSrc: pccomponents_powersupply_default2,
        title: 'MSI MAG A850GL PCIE5 850W 80 Plus Gold Power Supply',
        price: "RM 569",
    },
    {
        id: 338,
        brand: "Power Supply",
        category: "pccomponents",
        imgSrc: pccomponents_powersupply_default3,
        title: 'Cooler Master MWE 750 Bronze V2 PSU Power Supply ( 750W, MPE-7501-ACABW-B )',
        price: "RM 399",
    },
    {
        id: 339,
        brand: "Power Supply",
        category: "pccomponents",
        imgSrc: pccomponents_powersupply_default4,
        title: 'Cooler Master Elite 500 V4 PSU, 230V, 80 Plus White, Active PFC + Forward Topology, EPS 4+4 Connector (MPE-5001-ACABN)',
        price: "RM 219",
    },
    {
        id: 340,
        brand: "Power Supply",
        category: "pccomponents",
        imgSrc: pccomponents_powersupply_default5,
        title: 'MSI MPG A850GF Series 80 Plus Gold PSU',
        price: "RM 649",
    },
    {
        id: 341,
        brand: "Software",
        category: "pccomponents",
        imgSrc: pccomponents_software_default1,
        title: 'Microsoft Office 365 Business Stardard - ESD Version',
        price: "RM 495",
    },
    {
        id: 342,
        brand: "Software",
        category: "pccomponents",
        imgSrc: pccomponents_software_default2,
        title: 'Microsoft Office 365 Personal (1 User) - ESD Version',
        price: "RM 249",
    },
    {
        id: 343,
        brand: "Storage",
        category: "pccomponents",
        imgSrc: pccomponents_storage_default1,
        title: 'Samsung 990 EVO Plus NVMe M.2 PCIe 4.0 SSD (1TB, 2TB, 4TB)',
        price: "RM 750",
    },
    {
        id: 344,
        brand: "Storage",
        category: "pccomponents",
        imgSrc: pccomponents_storage_default2,
        title: 'Samsung 990 PRO Heatsink NVMe M.2 PCIe 4.0 SSD (1TB, 2TB,4TB)',
        price: "RM 989",
    },
    {
        id: 345,
        brand: "Storage",
        category: "pccomponents",
        imgSrc: pccomponents_storage_default3,
        title: 'Samsung 990 PRO NVMe M.2 PCIe 4.0 SSD (1TB, 2TB, 4TB)',
        price: "RM 880",
    },
    {
        id: 346,
        brand: "Storage",
        category: "pccomponents",
        imgSrc: pccomponents_storage_default4,
        title: 'Kingston M.2 2280 PCIe 4.0 NVME NV3 SSD (500GB /1TB / 2TB / 4TB)',
        price: "RM 849",
    },
    {
        id: 347,
        brand: "Storage",
        category: "pccomponents",
        imgSrc: pccomponents_storage_default5,
        title: 'TeamGroup P30 M.2 2280 NVMe PCIe SSD',
        price: "RM 689",
    },
    {
        id: 348,
        brand: "Thermal Paste",
        category: "pccomponents",
        imgSrc: pccomponents_tp_default1,
        title: 'Cooler Master High Performance Thermal Paste (HTK-002-U1)',
        price: "RM 29",
    },
    // pccomponents - END


    
    // dms - START
    {
        id: 401,
        brand: "Disk Station (Tower)",
        category: "dms",
        imgSrc: dms_dst_default1,
        title: 'Synology DiskStation DS425+ 4-Bay NAS Storage',
        price: "RM 2,449",
    },
    {
        id: 402,
        brand: "Disk Station (Tower)",
        category: "dms",
        imgSrc: dms_dst_default2,
        title: 'Synology DiskStation DS1825+ 8-Bay NAS Storage',
        price: "RM 5,439",
    },
    {
        id: 403,
        brand: "Disk Station (Tower)",
        category: "dms",
        imgSrc: dms_dst_default3,
        title: 'Synology DiskStation DS223j 2-Bay NAS Storage',
        price: "RM 879",
    },
    {
        id: 404,
        brand: "Disk Station (Tower)",
        category: "dms",
        imgSrc: dms_dst_default4,
        title: 'Synology DiskStation DS223 2-Bay NAS Storage',
        price: "RM 1,319",
    },
    {
        id: 405,
        brand: "Rack Station (Rack)",
        category: "dms",
        imgSrc: dms_rs_default1,
        title: 'Synology RS1221RP+ 8-Bay RackStation',
        price: "RM 7,929",
    },
    {
        id: 406,
        brand: "Rack Station (Rack)",
        category: "dms",
        imgSrc: dms_rs_default2,
        title: 'Synology RS1221+ 8-Bay RackStation',
        price: "RM 5,799",
    },
    {
        id: 407,
        brand: "Rack Station (Rack)",
        category: "dms",
        imgSrc: dms_rs_default3,
        title: 'Synology RS822RP+ 4-Bay RackStation',
        price: "RM 6,249",
    },
    {
        id: 408,
        brand: "Rack Station (Rack)",
        category: "dms",
        imgSrc: dms_rs_default4,
        title: 'Synology RS822+ 4-Bay RackStation',
        price: "RM 5,689",
    },
    // dms - END

    
    
    // wearables - START
    {
        id: 501,
        brand: "Apple",
        category: "wearables",
        imgSrc: wearables_apple_default1,
        title: 'Apple Watch Ultra 3 Ocean Band',
        price: "RM 3,699",
    },
    {
        id: 502,
        brand: "Apple",
        category: "wearables",
        imgSrc: wearables_apple_default2,
        title: '2025 Apple Watch SE Sport Band 3rd Generation',
        price: "RM 1,049",
    },
    {
        id: 503,
        brand: "Apple",
        category: "wearables",
        imgSrc: wearables_apple_default3,
        title: 'Apple Watch Series 11 Sport Band',
        price: "RM 1,799",
    },
    {
        id: 504,
        brand: "Apple",
        category: "wearables",
        imgSrc: wearables_apple_default4,
        title: '2024 Apple Watch Ultra 2 Ocean Band',
        price: "RM 2,999",
    },
    {
        id: 505,
        brand: "Garmin",
        category: "wearables",
        imgSrc: wearables_garmin_default1,
        title: 'Garmin Instinct Crossover AMOLED Rugged Hybrid GPS Smartwatch',
        price: "RM 2,589",
    },
    {
        id: 506,
        brand: "Garmin",
        category: "wearables",
        imgSrc: wearables_garmin_default2,
        title: 'Garmin Venu 4 Touch Advanced GPS Smartwatch (45mm)',
        price: "RM 2,319",
    },
    {
        id: 507,
        brand: "Garmin",
        category: "wearables",
        imgSrc: wearables_garmin_default3,
        title: 'Garmin vívoactive 6 GPS Smartwatch ( Black )',
        price: "RM 1,499",
    },
    {
        id: 508,
        brand: "Garmin",
        category: "wearables",
        imgSrc: wearables_garmin_default4,
        title: 'Garmin Forerunner 970 GPS Running Smartwatch',
        price: "RM 3,269",
    },
    {
        id: 509,
        brand: "Garmin",
        category: "wearables",
        imgSrc: wearables_garmin_default5,
        title: 'Garmin Approach S50 Advanced GPS Golf Smartwatch',
        price: "RM 1,999",
    },
    {
        id: 510,
        brand: "Garmin",
        category: "wearables",
        imgSrc: wearables_garmin_default6,
        title: 'Garmin Venu X1 Premium GPS Smartwatch',
        price: "RM 2,999",
    },
    {
        id: 511,
        brand: "Garmin",
        category: "wearables",
        imgSrc: wearables_garmin_default7,
        title: 'Garmin Fenix 8 Touch Amoled All-Rounded Advanced Outdoor GPS Smartwatch',
        price: "RM 5,149",
    },
    {
        id: 512,
        brand: "Garmin",
        category: "wearables",
        imgSrc: wearables_garmin_default8,
        title: 'Garmin Venu 3 Touch Advanced GPS Smartwatch (Black)',
        price: "RM 1,599",
    },
    // wearables - END


    
    // networking - START
    {
        id: 601,
        brand: "Starlink",
        category: "networking",
        imgSrc: networking_starlink_default1,
        title: 'Starlink Mini Mobility Mount (STA-04178000)',
        price: "RM 130",
    },
    {
        id: 602,
        brand: "Starlink",
        category: "networking",
        imgSrc: networking_starlink_default2,
        title: 'Starlink Mini Pivot Mount (STA-04172002)',
        price: "RM 340",
    },
    {
        id: 603,
        brand: "Starlink",
        category: "networking",
        imgSrc: networking_starlink_default3,
        title: 'Starlink Mini DC Power Cable 15m (STA-11699760)',
        price: "RM 170",
    },
    {
        id: 604,
        brand: "Starlink",
        category: "networking",
        imgSrc: networking_starlink_default4,
        title: 'Starlink V4 Standard Pipe Adapter Mount (STA-04759113)',
        price: "RM 399",
    },
    {
        id: 605,
        brand: "Starlink",
        category: "networking",
        imgSrc: networking_starlink_default5,
        title: 'Starlink V4 Standard Pivot Mount (STA-04759105)',
        price: "RM 560",
    },
	{
        id: 606,
        brand: "Asus",
        category: "networking",
        imgSrc: networking_asus_default1,
        title: 'ASUS ROG Strix GS-BE7200X Dual-band WiFi 7 Gaming Router (802.11be)',
        price: "RM 1,168",
    },
	{
        id: 607,
        brand: "Starlink",
        category: "networking",
        imgSrc: networking_starlink_default6,
        title: 'Starlink Mini (Integrated WiFi, Kickstand, Mini Pipe Adapter And Flat Mount, DC Power Cable 15m, Power Supply, Starlink Plug)',
        price: "RM 930",
    },
	{
        id: 608,
        brand: "Asus",
        category: "networking",
        imgSrc: networking_asus_default3,
        title: 'Asus ROG Rapture GT-BE98 BE25000 Quad-band WiFi 7 (802.11be) Gaming Router',
        price: "RM 3,549",
    },
	{
        id: 609,
        brand: "Asus",
        category: "networking",
        imgSrc: networking_asus_default4,
        title: 'ASUS TUF Gaming AX4200 Dual Band WiFi 6 Gaming Router ( TUF-AX4200 )',
        price: "RM 649",
    },
	{
        id: 610,
        brand: "Asus",
        category: "networking",
        imgSrc: networking_asus_default5,
        title: 'ASUS RT-AX82U 5400M Wireless Router Wifi6 Gaming High Performance Aura RGB',
        price: "RM 1,068",
    },
	{
        id: 611,
        brand: "Asus",
        category: "networking",
        imgSrc: networking_asus_default6,
        title: 'Asus ROG Rapture GT-AX11000 Tri-Band Wi-Fi Gaming Router',
        price: "RM 2,049",
    },
    {
        id: 612,
        brand: "D-Link",
        category: "networking",
        imgSrc: networking_dlink_default1,
        title: 'D-Link DWR-M930DS Wireless N300 4G Dual SIM LTE Router',
        price: "RM 209",
    },
    {
        id: 613,
        brand: "D-Link",
        category: "networking",
        imgSrc: networking_dlink_default2,
        title: 'D-Link DWR-M930 N300 4G LTE Router',
        price: "RM 149",
    },
    {
        id: 614,
        brand: "Totolink",
        category: "networking",
        imgSrc: networking_totolink_default1,
        title: 'Totolink LR1200 AC1200 Wireless Dual Band 4G LTE Router',
        price: "RM 309",
    },
    {
        id: 615,
        brand: "Totolink",
        category: "networking",
        imgSrc: networking_totolink_default2,
        title: 'Totolink X5000R Wi-Fi 6 AX1800 Wireless Dual Band Gigabit Router',
        price: "RM 245",
    },
    {
        id: 616,
        brand: "TP-Link",
        category: "networking",
        imgSrc: networking_tplink_default1,
        title: 'TP-Link Deco M4 AC1200 Whole Home Mesh Wi-Fi System (DECO M4 3-Pack)',
        price: "RM 509",
    },
    {
        id: 617,
        brand: "TP-Link",
        category: "networking",
        imgSrc: networking_tplink_default2,
        title: 'TP-Link Deco X60 AX3000 Whole Home Mesh Wi-Fi System Deco X60 (DECO X60 2 PACK)',
        price: "RM 1,049",
    },
    {
        id: 618,
        brand: "TP-Link",
        category: "networking",
        imgSrc: networking_tplink_default3,
        title: 'TP-Link 300Mbps Wireless N Ceiling Mount Access Point EAP115',
        price: "RM 199",
    },
    {
        id: 619,
        brand: "TP-Link",
        category: "networking",
        imgSrc: networking_tplink_default4,
        title: 'TP-LINK Archer C64 MU-MIMO Wave2 Gigabit AC1200 Wireless WiFi Router',
        price: "RM 169",
    },
	{
        id: 620,
        brand: "Asus",
        category: "networking",
        imgSrc: networking_asus_default2,
        title: 'Asus TUF-AX3000 TUF Gaming AX3000 Dual Band WiFi 6 Gaming Router',
        price: "RM 838",
    },
    // networking - END


    
    // printer - START
    {
        id: 701,
        brand: "Brother",
        category: "printer",
        imgSrc: printer_brother_default1,
        title: 'Brother MFC-L3760CDW Compact Colour Laser LED Multi-Function Touch Printer ( Print, Scan, Copy, Fax )',
        price: "RM 1,899",
    },
    {
        id: 702,
        brand: "Brother",
        category: "printer",
        imgSrc: printer_brother_default2,
        title: 'Brother Inkjet Tank DCP-T420W All-in-One Wireless Printer ( Print, copy, scan )',
        price: "RM 569",
    },
    {
        id: 703,
        brand: "HP",
        category: "printer",
        imgSrc: printer_hp_default1,
        title: 'HP DeskJet Ink Advantage Ultra 5138 All-in-One Wireless Printer ( Print, copy, scan )',
        price: "RM 349",
    },
    {
        id: 704,
        brand: "HP",
        category: "printer",
        imgSrc: printer_hp_default2,
        title: 'HP Color LASERJET Pro M155a Wireless Laser Printer ( Print Only )',
        price: "RM 529",
    },
    {
        id: 705,
        brand: "HP",
        category: "printer",
        imgSrc: printer_hp_default3,
        title: 'HP LASERJET 108w Wireless Monochrome Printer ( Print Only )',
        price: "RM 359",
    },
    {
        id: 706,
        brand: "HP",
        category: "printer",
        imgSrc: printer_hp_default4,
        title: 'HP LaserJet Pro 4003dn Wired Lazer Printer ( Print, Duplex )',
        price: "RM 1,299",
    },
    {
        id: 707,
        brand: "HP",
        category: "printer",
        imgSrc: printer_hp_default5,
        title: 'HP Smart Tank 790 Printer Wireless All-in-One Inkjet Printer ( Print, Copy, Scan, Fax, ADF and Wireless )',
        price: "RM 1,359",
    },
    {
        id: 708,
        brand: "HP",
        category: "printer",
        imgSrc: printer_hp_default6,
        title: 'HP LaserJet Pro MFP 4103fdn Printer (Print, Scan, Copy, Fax, ADF and Duplex)',
        price: "RM 2,529",
    },
    {
        id: 709,
        brand: "HP",
        category: "printer",
        imgSrc: printer_hp_default7,
        title: 'HP Smart Tank 580 Printer Wireless All-in-One Inkjet Printer ( Print, Scan Copy )',
        price: "RM 489",
    },
    {
        id: 710,
        brand: "HP",
        category: "printer",
        imgSrc: printer_hp_default8,
        title: 'HP LaserJet M211d Printer',
        price: "RM 469",
    },
    {
        id: 711,
        brand: "Canon",
        category: "printer",
        imgSrc: printer_canon_default1,
        title: 'Canon MAXIFY MB5170 High Speed Multi-Function Business Printer ( Print, Scan, Copy, Fax )',
        price: "RM 949",
    },
    {
        id: 712,
        brand: "Canon",
        category: "printer",
        imgSrc: printer_canon_default2,
        title: 'Canon imageCLASS LASERJET MF662Cdw All-In-One Wireless Printer ( Print, Scan, Copy ）',
        price: "RM 1,479",
    },
    {
        id: 713,
        brand: "Canon",
        category: "printer",
        imgSrc: printer_canon_default3,
        title: 'Canon imageCLASS LASERJET MF284DW All-In-One Wireless Printer ( Print, Scan, Copy ）',
        price: "RM 1,119",
    },
    {
        id: 714,
        brand: "Canon",
        category: "printer",
        imgSrc: printer_canon_default4,
        title: 'Canon Pixma G3770 Wireless MegaTank Printer White ( Print, Scan, Copy )',
        price: "RM 699",
    },
    {
        id: 715,
        brand: "Canon",
        category: "printer",
        imgSrc: printer_canon_default5,
        title: 'Canon imageCLASS MF3010 Monochrome Compact Laser Printer ( Print, Scan, Copy )',
        price: "RM 719",
    },
    {
        id: 716,
        brand: "Canon",
        category: "printer",
        imgSrc: printer_canon_default6,
        title: 'Canon G3010 AIO Wireless Printer ( Print, Scan, Copy )',
        price: "RM 479",
    },
    {
        id: 717,
        brand: "Canon",
        category: "printer",
        imgSrc: printer_canon_default7,
        title: 'Canon Pixma E4570 Compact Wireless Inkjet All-in-One Printer ( Print, Scan, Copy, Fax )',
        price: "RM 459",
    },
    {
        id: 718,
        brand: "Epson",
        category: "printer",
        imgSrc: printer_epson_default1,
        title: 'Epson LQ-590IIN Impact Printer (Impact Dot Matrix)',
        price: "RM 3,299",
    },
    {
        id: 719,
        brand: "Epson",
        category: "printer",
        imgSrc: printer_epson_default2,
        title: 'Epson EcoTank L5290 A4 Wi-Fi All-in-One Ink Tank Printer (Print, Scan, Copy, Fax with ADF)',
        price: "RM 1,089",
    },
    {
        id: 720,
        brand: "Epson",
        category: "printer",
        imgSrc: printer_epson_default3,
        title: 'Epson L3250 AIO WIFI PRINTER (Print, Copy, Scan)',
        price: "RM 509",
    },
    {
        id: 721,
        brand: "Epson",
        category: "printer",
        imgSrc: printer_epson_default4,
        title: 'Epson EcoTank L3210 All-in-One Ink Tank Printer',
        price: "RM 459",
    },
    {
        id: 722,
        brand: "Epson",
        category: "printer",
        imgSrc: printer_epson_default5,
        title: 'Epson LQ-310 Dot Matrix Printer',
        price: "RM 789",
    },
    // printer - END



    // homeappliance - START
    {
        id: 801,
        brand: "Xiaomi",
        category: "homeappliance",
        imgSrc: homeappliance_xiaomi_default1,
        title: 'Xiaomi A27Ui 27" 4K IPS 60Hz Monitor ( HDMI, DP, USB-C, 3 Yrs Wrty )',
        price: "RM 919",
    },
    {
        id: 802,
        brand: "Xiaomi",
        category: "homeappliance",
        imgSrc: homeappliance_xiaomi_default2,
        title: 'Xiaomi G27Qi 27" 2K Fast IPS 180Hz Gaming Monitor ( HDMI, DP, 3 Yrs Wrty )',
        price: "RM 689",
    },
    {
        id: 803,
        brand: "Xiaomi",
        category: "homeappliance",
        imgSrc: homeappliance_xiaomi_default3,
        title: 'Xiaomi A27Qi 27" 2K IPS 100Hz Monitor ( HDMI, DP, 3 Yrs Wrty )',
        price: "RM 499",
    },
    {
        id: 804,
        brand: "Xiaomi",
        category: "homeappliance",
        imgSrc: homeappliance_xiaomi_default4,
        title: 'Xiaomi G24i 2026 23.8" FHD Fast IPS 200Hz Gaming Monitor ( HDMI, DP, 3 Yrs Wrty )',
        price: "RM 399",
    },
    {
        id: 805,
        brand: "Xiaomi",
        category: "homeappliance",
        imgSrc: homeappliance_xiaomi_default5,
        title: 'Xiaomi G34WQi 34" WQHD 180Hz Curved Gaming Monitor ( HDMI, DP, 3 Yrs Wrty )',
        price: "RM 1,199",
    },
    {
        id: 806,
        brand: "Padbot",
        category: "homeappliance",
        imgSrc: homeappliance_padbot_default1,
        title: 'PadBot E1 Intelligent Open Source ROS Omnidirectional Four-Wheel UGV Mobile Robot Wire Control Chassis China Scientific',
        price: "RM 509",
    },
    {
        id: 807,
        brand: "Padbot",
        category: "homeappliance",
        imgSrc: homeappliance_padbot_default2,
        title: 'PabBot T2 Kids Pet Robot Emo Remote Control Differential Drive Telepresence Video Call Educational Toy Robot',
        price: "RM 2069",
    },
    // homeappliance - END

];